export const assignments = state => state.assignments
export const statusCounters = state => state.statusCounters
export const countPending = state => state.countPending

